<template>
  <v-app>
    <nav>
      <v-app-bar style="background-color: white;" prominent app hide-on-scroll>
        <v-img @click="volver" src="@/assets/logo-sin-propiedades.jpg" 
          style="margin: 0 2%; max-width:13rem; cursor: pointer;"></v-img>
      </v-app-bar>
    </nav>

    <div style="margin: 1rem 0; max-height: 100%;">
      <h2 style="margin: 0 auto; width: 150px;" class="mt-6">COD. {{$route.params.propiedad.codigo}}</h2>
      <v-carousel style="margin: 0 auto; max-height: 47vh;" class="slider2 pt-0" height="100%" hide-delimiters>
        <v-carousel-item style="max-height: 47vh;" v-for="(fotos,i) in $route.params.propiedad.fotos" :key="i"
        reverse-transition="fade-transition" transition="fade-transition">
          <v-img alt="Fotos de propiedad" :src="`${fotos}`" 
          style="width: 100%; max-height: 48vh; border-bottom: solid 20px #97b699;"></v-img>
        </v-carousel-item>
      </v-carousel>
    </div>

    <div style="display: flex; justify-content:center;" align="center">
      <span v-if="($route.params.propiedad.comprar)?this.operacion='VENTA':this.operacion='ALQUILER'" 
        class="operacion white--text mt-2">{{operacion}}</span>
        <h2 class="mt-2 direc" style="color: #97b699; font-family: Century Gothic;">{{$route.params.propiedad.direccion}}</h2>
    </div>

    <span class="my-4 mx-auto">
      <h2 class="caracteristicas">Características principales</h2>
      <div v-show=$route.params.propiedad.caracteristicas[0] class="alinear pt-3 pr-12" style="margin-left: 30%;">
        <v-icon x-small color="#97b699"> mdi-circle </v-icon>
        <p class="fuenteTexto ml-2 py-auto my-auto">{{$route.params.propiedad.caracteristicas[0]}}</p>
      </div>
      <div v-show=$route.params.propiedad.caracteristicas[1] class="alinear" style="margin-left: 30%;">
        <v-icon x-small color="#97b699"> mdi-circle </v-icon>
        <p class="fuenteTexto ml-2 py-auto my-auto">{{$route.params.propiedad.caracteristicas[1]}}</p>
      </div>
      <div v-show=$route.params.propiedad.caracteristicas[2] class="alinear" style="margin-left: 30%;">
        <v-icon x-small color="#97b699"> mdi-circle </v-icon>
        <p class="fuenteTexto ml-2 py-auto my-auto">{{$route.params.propiedad.caracteristicas[2]}}</p>
      </div>
      <div v-show=$route.params.propiedad.caracteristicas[3] class="alinear" style="margin-left: 30%;">
        <v-icon x-small color="#97b699"> mdi-circle </v-icon>
        <p class="fuenteTexto ml-2 py-auto my-auto">{{$route.params.propiedad.caracteristicas[3]}}</p>
      </div>
    </span>

    <div class="iconos">
      <div v-show="($route.params.propiedad.habitacion) ? true:false" class="mx-3 alinear"> 
        <v-icon class="mb-5 mr-2" size="50px" color="#97b699">mdi-bed</v-icon> 
        <span>{{$route.params.propiedad.habitacion}}<h4>Dormitorios</h4></span>
      </div>
      <div v-show="($route.params.propiedad.baño) ? true:false" class="mx-3 alinear"> 
        <v-icon class="mb-5 mr-2" size="50px" color="#97b699">mdi-shower</v-icon> 
        <span>{{$route.params.propiedad.baño}}<h4>Baños</h4></span>
      </div>
      <div v-show="($route.params.propiedad.mts) ? true:false" class="mx-3 alinear"> 
        <v-icon class="mb-5 mr-2" size="40px" color="#97b699">mdi-ruler</v-icon> 
        <span>{{$route.params.propiedad.mts}}<h4>M²</h4></span>
      </div>
    </div>

    <div class="desc" style="text-align: center;">
      <h2 style="font-family: raleway; font-size: xx-large;">Descripción</h2>
      <p class="fuenteTexto">{{$route.params.propiedad.descripcion}}</p>
    </div>


    <div  style="margin: 1rem 20%; display: flex; align-items: center; padding-top: 0;">
      <div style=" width: 50%;" v-show="extras">
        <h2 style="margin-left: 30%; font-family: raleway;">Extras</h2>
        <div v-show=$route.params.propiedad.oficina class="alinear" style="margin-left: 30%;">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 py-auto my-auto fuenteTexto">Oficina</p>
        </div>
        <div v-show=$route.params.propiedad.galeria style="margin-left: 30%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Galería</p>
        </div>
        <div v-show=$route.params.propiedad.pileta style="margin-left: 30%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Pileta</p>
        </div>
        <div v-show=$route.params.propiedad.garage style="margin-left: 30%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Garaje</p>
        </div>
        <div v-show=$route.params.propiedad.quincho style="margin-left: 30%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Quincho</p>
        </div>
        <div v-show=$route.params.propiedad.galpon style="margin-left: 30%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Galpón</p>
        </div>
        <div v-show=$route.params.propiedad.local style="margin-left: 30%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Local</p>
        </div>
      </div>

      <div :v-show="servicios" style="padding: 0 auto; width: 50%; padding-top: 0;">
        <h2 style="margin-left: 35%; font-family: raleway;">Servicios</h2>
        <div v-show=$route.params.propiedad.agua style="margin-left: 35%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 py-auto my-auto fuenteTexto">Agua</p>
        </div>
        <div v-show=$route.params.propiedad.luz style="margin-left: 35%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Luz</p>
        </div>
        <div v-show=$route.params.propiedad.gas style="margin-left: 35%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Gas</p>
        </div>
        <div v-show=$route.params.propiedad.cloacas style="margin-left: 35%;" class="alinear">
          <v-icon x-small color="#97b699"> mdi-circle </v-icon>
          <p class="ml-2 my-auto fuenteTexto">Cloacas</p>
        </div>
      </div>
    </div>

    <div class="precio">
      <div class="alinear">
        <h1 style="color: #97b699;">USD {{$route.params.propiedad.precio}}</h1>
        <v-spacer></v-spacer>
        <div class="my-auto">¡Quiero saber más de esta propiedad!</div>
      </div>
      <div class="alinear">
        <v-spacer></v-spacer>
        <a :href=wpp target="_blank" style="text-decoration: none;">
          <v-btn class="white--text" color="#97b699" style="border-radius: 0.5rem;">
            <v-icon>mdi-whatsapp</v-icon> CONTACTANOS
          </v-btn>
        </a>
      </div>
    </div>

    <div class="piePagina" align="center">
      <a href="https://www.instagram.com/invites/contact/?i=sifpxfh5bktu&utm_content=p2mr61l" 
      target="_blank" style="text-decoration: none;">
        <v-btn class="icono" icon>
          <v-icon x-large class="white--text icono">mdi-instagram</v-icon>
        </v-btn>
      </a>
      <a href="https://www.facebook.com/AlfonsinaGrandPropiedades/" 
      target="_blank" style="text-decoration: none;">
        <v-btn class="icono" icon>
          <v-icon x-large class="white--text icono">mdi-facebook</v-icon>
        </v-btn>
      </a>
      <v-row justify="center" class="my-1" style="max-width: 100%;">
        <v-icon class="white--text mb-4 mr-2">mdi-email-outline</v-icon>
        <p style="color: white;" class="mailMb">info@alfonsinagrandpropiedades.com.ar</p>
      </v-row>
      <p style="color: grey;">Terminos y condiciones | Politica de privacidad</p>
      <div style="background-color: white;">
        <v-img src="@/assets/logo1.jpg" alt="logo" style="width: 20rem; border-radius: 100%;">
        </v-img>
      </div>
    </div>
  </v-app>
</template>

<script>

export default {
  name: 'FichaC',
  data() {
    return {
      extras: false,
      servicios: false,
      wpp : `https://wa.me/5491176052212?text=Hola!%20Estoy%20interesado%20en%20la%20propiedad%20${this.$route.params.propiedad.codigo}`,
    }
  },
  methods: {
    volver() {
      this.$router.push('/')
    },
    scrollToTop() {
      window.scrollTo(0,0)
    },
    verificarServicios() {
      if(this.$route.params.propiedad.agua || this.$route.params.propiedad.luz || 
      this.$route.params.propiedad.gas || this.$route.params.propiedad.cloacas) this.servicios = true

      if(this.$route.params.propiedad.oficina || this.$route.params.propiedad.galeria || 
      this.$route.params.propiedad.pileta || this.$route.params.propiedad.garage ||
      this.$route.params.propiedad.quincho || this.$route.params.propiedad.galpon ||
      this.$route.params.propiedad.local) this.extras=true 
      console.log(this.servicios, this.extras)
    }
  },
  mounted () {
    this.scrollToTop()
    this.verificarServicios()
  }
};
</script>
<style scoped>
  .operacion{
    margin-left: 5px;
    margin-right: 20px;
    height: 35px; 
    width: 65px;
    background-color: #97b699;
    padding: 5px 5px;
  }
  .fuenteTexto{
    font-family: 'Kanit', sans-serif;
    font-weight: 900;
    font-size: larger;
  }
  .desc {
    margin: 0 20%;
  }
  .slider2{
    width: 95vh;
    height: 100%;
  }
  .iconos{
    display: flex;
    justify-content: flex-start;
    margin: 0.5rem auto;
  }
  .alinear{
    display: flex;
    justify-content: flex-start;
  }
  .precio{
    margin: 1rem 20%;
  }
  .contacto{
    width: 5rem;
    margin-right: 20%;
  }
  .caracteristicas{
    font-family: raleway; 
    font-size: xx-large;
  }
  .btnVolver{
    font-size:x-large;
    margin-right: 30px; 
    color: #97b699;
    margin-top: 50px;
  }

  @media screen and (max-width: 700px) {
    .precio{
      margin: 1rem 5%;
    }
    .contacto{
    margin-right: 10%;
    }
    .slider2{
      width: 55vh;
    }
    .desc{
      margin: 0 10%;
    }
    .btnVolver{
      margin-left: 100px; 
      margin-bottom: 7px;
    }
  }
  @media screen and (max-width: 375px) {
    .btnVolver{
      margin-left: 80px; 
    }
  }
  @media screen and (max-width: 320px) {
    .caracteristicas{
      font-size: large;
    }
    .btnVolver{
      margin-left: 50px; 
    }
  }
</style>